"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.51,15.72h0a5.54,5.54,0,0,1,.86-2.63l-.88,0c-3,0-6.06-.75-7.45-2v2C3.06,14.3,6.38,15.72,10.51,15.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.51,12.37c.51,0,1,0,1.49-.06a5.54,5.54,0,0,1,5.62-1.59,2.76,2.76,0,0,0,.34-.27V8c-1.59,1.07-4.63,1.74-7.45,1.74S4.45,9,3.06,7.8v2C3.06,10.95,6.38,12.37,10.51,12.37Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.51,9C13.92,9,16.93,8.08,18,7.1V6.41c0-1.88-3.27-3.35-7.45-3.35S3.06,4.53,3.06,6.41C3.06,7.59,6.38,9,10.51,9Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M10.51,16.47c-3,0-6.06-.75-7.45-2V16.1c0,1.88,3.27,3.35,7.45,3.35.38,0,.74,0,1.1,0a5.54,5.54,0,0,1-1.08-2.94Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M16.1,11.26a4.84,4.84,0,1,0,4.84,4.84A4.85,4.85,0,0,0,16.1,11.26Zm1.21,5.65h-2V13.68a.4.4,0,0,1,.81,0V16.1h1.21a.4.4,0,1,1,0,.81Z"
  })));
};

exports["default"] = _default;